import './js/eventmanager.js';
import './js/gtm.js';
import './style/main.scss';

import initaccordion from './js/accordion.js';
import setScreenshot from './js/screenshot.js';
import validateLoginForm from './js/form-fatp-login.js';
import validateSignUpForm from './js/form-fatp-sign-up.js';
import validateEmail from './js/form-fatp-email-verification.js'
import validateEmailToken from './js/verify-email.js'
import validateAddListings from './js/form-fatp-add-listings.js'
import validateEditListings from './js/form-fatp-edit-listings.js'
import verifiedEmailAcceptTerms from './js/form-fatp-verified-email-accept-terms.js';
import showListings from './js/view-listings.js';
import getUserDetails from './js/get-user-details.js';
import logout from './js/logout.js';
import unsubscribe from './js/form-unsubscribe.js';

if (location.pathname == '/access-your-listing') {
  validateLoginForm();
  validateEmail();
} else if (location.pathname == '/register-to-be-listed') {
  validateSignUpForm();
  validateEmail();
} else if (/^\/verify-email/.test(location.pathname)) {
  validateEmailToken();
  verifiedEmailAcceptTerms();
} else if (/^\/listings/.test(location.pathname)) {
  showListings();
} else if (/^\/add-listing/.test(location.pathname)) {
  validateAddListings();
} else if (/^\/edit-listing/.test(location.pathname)) {
  validateEditListings();
} else if (/^\/unsubscribe/.test(location.pathname)) {
  unsubscribe();
}

setScreenshot();
initaccordion();
getUserDetails();
logout();

require.context('./views/', true);

if (module.hot) {
  module.hot.accept();
}
